import React from 'react';
import { Copy, Flex, Stack } from '@grubhubprod/gh-cookbook-react';
import { STATUS_CONFIG } from 'src/components/enterprise/features/Reporting/ManageReportsPage/components/ReportStatusIcon/ReportStatusIcon.utils';

export const ReportsStatusLegend: React.FC = () => (
  <Flex alignItems="center" role="list">
    {Object.entries(STATUS_CONFIG).map(([displayStatus, statusConfig]) => {
      const { color, label, legend } = statusConfig;
      const { Icon, size: iconSize = '24px' } = legend;

      return (
        <Stack key={displayStatus} x="md" role="listitem">
          <Flex alignItems="center">
            <Stack x="xx-sm">
              <Copy variant="body" color={color}>
                <Icon size={iconSize} />
              </Copy>
            </Stack>
            <Copy variant="caption">{label}</Copy>
          </Flex>
        </Stack>
      );
    })}
  </Flex>
);
